import { useEffect } from 'react';

const headStyleActive = { overflow: 'hidden', position: 'fixed' };
const headStyleRestored = { overflow: 'auto', position: 'relative' };

const useFreezeHTML = (shouldFreezeHTML, unless = false) => {
  useEffect(() => {
    if (unless) {
      return;
    }

    Object.assign(document.documentElement.style, shouldFreezeHTML ? headStyleActive : headStyleRestored);
  }, [shouldFreezeHTML]);
};

export default useFreezeHTML;
